import service from '@/store/services/workshop/spare_part_master-service';

const state = {
  list: {},
  spare_part_master: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, spare_part_master) => {
    state.spare_part_master = spare_part_master;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((spare_part_master) => { commit('SET_RESOURCE', spare_part_master); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((spare_part_master) => { commit('SET_RESOURCE', spare_part_master); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((spare_part_master) => { commit('SET_RESOURCE', spare_part_master); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((spare_part_master) => { commit('SET_RESOURCE', spare_part_master); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  spare_part_master: state => state.spare_part_master,
  page: state => state.meta.page,
};
 
const spare_part_master = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default spare_part_master;
